import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './core/interceptor/http-interceptor';
import { assignmentErrorInterceptor } from './core/interceptor/assignment-error.interceptor';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {DatePipe, registerLocaleData} from "@angular/common";
import localeKy from '@angular/common/locales/ky'
import { provideDaterangepickerLocale } from "ngx-daterangepicker-bootstrap";
import { FieldTranslatePipe } from './shared/pipes/field-translate.pipe';

registerLocaleData(localeKy);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([httpInterceptor, assignmentErrorInterceptor])),
    { provide: LOCALE_ID, useValue: 'ky-KG' },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
          deps: [HttpClient]
        }
      }
    )),
    provideDaterangepickerLocale({
      separator: ' - ',
      applyLabel: 'Okay',
    }),
    DatePipe,
    FieldTranslatePipe,
  ]
};
